import { render, staticRenderFns } from "./AcademyTeacherList.vue?vue&type=template&id=0b052a24&scoped=true&lang=pug&"
import script from "./AcademyTeacherList.vue?vue&type=script&lang=ts&"
export * from "./AcademyTeacherList.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyTeacherList.vue?vue&type=style&index=0&id=0b052a24&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b052a24",
  null
  
)

export default component.exports